import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class SaPickingWaveService extends ApiService {

    select(params: any = {}) {
        return super.get(`/sa-picking-waves/select`, params);
    }
}
